import React, { useState, useEffect } from 'react';
import { Button, Typography, IconButton, Tooltip } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip, faTrash } from "@fortawesome/free-solid-svg-icons";

function AttachmentUploader({
                                onAttachmentSelected,
                                defaultValue = null,
                                onAttachmentRemoved = () => {},
                                multiple = false
                            }) {
    const [attachments, setAttachments] = useState([]);

    useEffect(() => {
        if (defaultValue) {
            let defaults = multiple ? defaultValue : [defaultValue];

            if (typeof defaults === 'string') {
                defaults = defaults.split(',').map(str => str.trim()).filter(Boolean);
            } else if (!Array.isArray(defaults)) {
                defaults = [defaults];
            }

            setAttachments(defaults);
            onAttachmentSelected(multiple ? defaults : defaults[0]);
        }
    }, [defaultValue]);

    const handleChange = (event) => {
        const files = Array.from(event.target.files).filter(file =>
            file.type.startsWith('application/') || file.name // fallback
        );

        const filePreviews = files.map(file => ({
            file,
            name: file.name,
            url: URL.createObjectURL(file)
        }));

        const newAttachments = multiple ? [...attachments, ...filePreviews] : filePreviews;

        setAttachments(newAttachments);
        onAttachmentSelected(multiple ? files : files[0]);
    };

    const handleRemove = (index) => {
        const updated = [...attachments];
        updated.splice(index, 1);
        setAttachments(updated);
        onAttachmentRemoved(index);
    };

    return (
        <div>
            <input
                accept="application/*"
                id="upload-attachment"
                type="file"
                multiple={multiple}
                style={{ display: 'none' }}
                onChange={handleChange}
            />

            <label htmlFor="upload-attachment">
                <Button
                    variant="outlined"
                    color="primary"
                    component="span"
                    startIcon={<FontAwesomeIcon icon={faPaperclip} />}
                    style={{
                        padding: '10px 20px',
                        borderRadius: '8px',
                        textTransform: 'none',
                        fontWeight: 500,
                        fontSize: '14px',
                        boxShadow: 'none'
                    }}
                >
                    Ajouter des pièces jointes
                </Button>
            </label>

            {attachments.length > 0 && (
                <div style={{ marginTop: 16 }}>
                    <ul style={{ paddingLeft: 16 }}>
                        {attachments.map((att, index) => (
                            <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                <FontAwesomeIcon icon={faPaperclip} style={{ marginRight: 8 }} />
                                <span>{att.name || att.split('/').pop() || 'Fichier sans nom'}</span>
                                <Tooltip title="Supprimer">
                                    <IconButton
                                        onClick={() => handleRemove(index)}
                                        size="small"
                                        color="secondary"
                                        style={{ marginLeft: 8 }}
                                    >
                                        <FontAwesomeIcon icon={faTrash} />
                                    </IconButton>
                                </Tooltip>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}

export default AttachmentUploader;
